import { render, staticRenderFns } from "./correctionsTip.vue?vue&type=template&id=2ec8dd4e&scoped=true"
import script from "./correctionsTip.vue?vue&type=script&lang=js"
export * from "./correctionsTip.vue?vue&type=script&lang=js"
import style0 from "./correctionsTip.vue?vue&type=style&index=0&id=2ec8dd4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec8dd4e",
  null
  
)

export default component.exports